// Shared phone helpers for the SMS module.
// Mirrors the formatters from the legacy SMS Dashboard so the UX feels identical.

export const LINE1_NUMBER = "+17576899854";
export const LINE2_NUMBER = "+17576897188";
export const OUR_NUMBERS = [LINE1_NUMBER, LINE2_NUMBER];

export const PHONE_LINES: { number: string; label: string; line: "line1" | "line2" }[] = [
  { number: LINE1_NUMBER, label: "Line 1 — (757) 689-9854", line: "line1" },
  { number: LINE2_NUMBER, label: "Line 2 — (757) 689-7188", line: "line2" },
];

/** Pretty-print a stored E.164 number like `+17576899854` → `(757) 689-9854`. */
export function formatPhone(number: string | null | undefined): string {
  if (!number) return "";
  const cleaned = number.replace(/\D/g, "");
  if (cleaned.length === 11 && cleaned[0] === "1") {
    return `(${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return number;
}

/** Input-side formatter — progressively formats as the user types. */
export function formatPhoneInput(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/** Convert a formatted `(757) 689-9854` back into E.164 `+17576899854`. Returns null if invalid. */
export function toE164(formatted: string): string | null {
  const digits = formatted.replace(/\D/g, "");
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits[0] === "1") return `+${digits}`;
  return null;
}

export function lineLabel(line: string | null | undefined): string {
  if (line === "line1") return "L1";
  if (line === "line2") return "L2";
  return "";
}

export function fullLineLabel(line: string | null | undefined): string {
  if (line === "line1") return "Line 1";
  if (line === "line2") return "Line 2";
  return "";
}
